import classnames from 'classnames'

import Box from '~/core/Box'
import Tooltip from '~/core/Tooltip'
import Image from '~/core/Image'
import Text from '~/core/Text'
import styles from '~/apps/consumer/components/PartViewerModal/styles.css'
import { HEADER_STYLES } from '~/apps/consumer/components/PartViewerModal/logic'
import { PartPhotoType } from '~/apps/consumer/components/PartViewerModal/types'

export default function PartPhoto(props: PartPhotoType) {
    const {
        photos,
        selectedInspectionDocument,
        setInspectionDocumentIdx,
        numF5Images,
    } = props

    const numF5ImagesSelected = numF5Images || 0

    return (
        <>
            <Text style={HEADER_STYLES}>Part photos</Text>
            <Box
                direction="row"
                className={styles.wrapperForPhotoAndDocumentTiles}
            >
                {photos.map((photo, idx) => {
                    const isSelected =
                        idx + numF5ImagesSelected === selectedInspectionDocument

                    return (
                        <Tooltip title={photo.fileName} key={photo.createdAt}>
                            <Box
                                onClick={() =>
                                    setInspectionDocumentIdx(
                                        idx + numF5ImagesSelected,
                                    )
                                }
                                data-test-target="part-photo-thumbnail"
                            >
                                <Image
                                    className={classnames(
                                        styles.inspectionThumbnail,
                                        isSelected &&
                                            styles.inspectionThumbnailSelected,
                                    )}
                                    src={photo.downloadUrl}
                                />
                            </Box>
                        </Tooltip>
                    )
                })}
            </Box>
        </>
    )
}
